import React from 'react';
import logo from '../asset/logo.png';

const IntroSection = ({ title, text }) => {
  return (
    <section className="intro">
      <h2 className='intro-title'>{title}</h2>
      <div>
        <img src={logo} alt="Uni Studio Logo" className="uni-logo" />
        <p className='company-name'>Uni Studio</p>
      </div>
      <p className='intro-text'>{text}</p>
    </section>
  );
}

export default IntroSection;
